export default "__VITE_ASSET__78728165__"